import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';
import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import { GameCenterComponentGridAreas } from '../../styles';

export const PenaltyContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.penalties};
`;

export const TeamContainer = styled(TeamDisplay)`
    flex: initial;

    img {
        height: 24px;
        width: 36px;
    }
`;

export const centeredText = `
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const penaltyStyle = (theme) => `
    border-left: solid 1px ${theme.Surface.border};
    padding-left: 16px;
    
    display: flex;
    align-items: center;
    height: 100%;
`;

export const PeriodDescription = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle1}
    width: 100%;
    color: ${({ theme }) => theme.Text.secondary};
`;
